"use client";

import {ExtendedCareEntrySearchResult} from "@components/CareEntryRow";
import CareDiscoverySearch from "@components/Reason/CareDiscoverySearch/CareDiscoverySearch";
import {useSendDefaultResultsViewedEvent} from "@components/Reason/CareDiscoverySearch/careDiscoveryAnalytics";
import React, {ComponentProps} from "react";
import {Breakpoint} from "src/constants/breakpoint";
import {useTwMediaQuery} from "src/hooks/useTwMediaQuery";
import {RootStateApptReason, RootStateLocation} from "src/store/types";

const ClientSearchWrapper = ({
  reasons,
  locations,
  defaultResults,
  dialogTitle,
  isSearchEnabled,
  headerImages,
}: {
  reasons: RootStateApptReason[];
  locations: RootStateLocation[];
  defaultResults: ExtendedCareEntrySearchResult[];
  dialogTitle: string;
  isSearchEnabled: boolean;
  headerImages?: ComponentProps<typeof CareDiscoverySearch>["headerImages"];
}) => {
  const isSm = !useTwMediaQuery(Breakpoint.LG);

  const viewId = useSendDefaultResultsViewedEvent({
    results: defaultResults,
    isLoading: false,
    reasons,
  });

  return (
    <CareDiscoverySearch
      reasons={reasons}
      locations={locations}
      defaultResults={defaultResults}
      dialogTitle={dialogTitle}
      isSearchEnabled={isSearchEnabled}
      headerImages={headerImages}
      hideHeadline={isSm}
      viewId={viewId}
    />
  );
};

export default React.memo(ClientSearchWrapper);
